var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophyStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_306_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2188 4.125H20.4062C21.4727 4.125 22.375 5.02734 22.334 6.13477C22.293 6.33984 22.293 6.54492 22.293 6.75H26.6406C27.1738 6.75 27.625 7.20117 27.625 7.73438C27.625 11.5078 26.3125 14.1328 24.5488 15.9375C22.7852 17.7012 20.6523 18.6035 19.0527 19.0547C18.1094 19.3418 17.4531 20.1621 17.4531 20.9824C17.4531 21.8438 18.1504 22.5 18.9707 22.5H19.75C20.4473 22.5 21.0625 23.1152 21.0625 23.8125C21.0625 24.5508 20.4473 25.125 19.75 25.125H11.875C11.1367 25.125 10.5625 24.5508 10.5625 23.8125C10.5625 23.1152 11.1367 22.5 11.875 22.5H12.6133C13.4746 22.5 14.1719 21.8027 14.1719 20.9824C14.1719 20.1621 13.5156 19.3418 12.5312 19.0547C10.9316 18.6035 8.79883 17.7012 7.07617 15.9375C5.27148 14.1328 4 11.5078 4 7.73438C4 7.20117 4.41016 6.75 4.98438 6.75H9.29102C9.29102 6.54492 9.29102 6.33984 9.25 6.13477C9.20898 5.02734 10.1113 4.125 11.2188 4.125ZM9.45508 8.71875H5.96875C6.17383 11.4258 7.19922 13.2715 8.4707 14.543C9.41406 15.5273 10.5625 16.2246 11.6289 16.6758C10.6855 15.0352 9.82422 12.5332 9.45508 8.71875ZM19.9551 16.6758C21.0215 16.2246 22.1699 15.5273 23.1133 14.543C24.3848 13.2715 25.4102 11.4258 25.6152 8.71875H22.1289C21.7598 12.5332 20.8984 15.0352 19.9551 16.6758ZM16.0996 7.69336C15.9766 7.44727 15.6074 7.44727 15.4844 7.69336L14.7051 9.29297C14.6641 9.375 14.582 9.45703 14.459 9.45703L12.6953 9.70312C12.4492 9.74414 12.3262 10.0723 12.5312 10.2773L13.8027 11.5078C13.8848 11.5898 13.9258 11.7129 13.8848 11.7949L13.5977 13.5586C13.5566 13.8457 13.8438 14.0508 14.0488 13.8867L15.6484 13.0664C15.7305 13.0254 15.8535 13.0254 15.9355 13.0664L17.5352 13.9277C17.7812 14.0508 18.0273 13.8457 17.9863 13.5586L17.6992 11.7949C17.6992 11.7129 17.6992 11.5898 17.7812 11.5078L19.0527 10.2773C19.2578 10.1133 19.1348 9.74414 18.8887 9.74414L17.125 9.45703C17.002 9.45703 16.9199 9.375 16.8789 9.29297L16.0996 7.69336Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_306_7",
    x: 0,
    y: 0.125,
    width: 31.625,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_306_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_306_7",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyStar);
export default __webpack_public_path__ + "static/media/trophy-star.71c78e130001447380c528724994d446.svg";
export { ForwardRef as ReactComponent };